import 'ress';
import 'core-js/stable';
import '../scss/style.scss';
import $ from 'jquery';
import 'slick-carousel';
import common from './common';

common();

$(document).ready(() => {
});
